export const HOME_PAGE = 'index';
export const BOOKID = 10001;